import Swal from 'sweetalert2';
function sweetAlertTwoButtons(title, text, type, confirmButtonText, cancelButtonText?) {
    const swalFormat = {
        title,
        text,
        type,
        showCancelButton: cancelButtonText ? true : false,
        confirmButtonColor: cancelButtonText ? '#d33' : '#5163B7',
        cancelButtonColor: '#5163B7',
        confirmButtonText,
        cancelButtonText

    };
    return swalFormat;
    // return Swal.fire(
    //     swalFormat
    //   );
}

function sweetAlertOneButtons(title, text, type, confirmButtonText) {
    const swalFormat = {
        title,
        text,
        type,
        confirmButtonColor: type === 'warning' || type === 'error' ? '#d33' : '#5163B7',
        confirmButtonText

    };
    return swalFormat;
    // return Swal.fire(
    //     swalFormat
    //   );
}

export function sweetAlert(title, text, type, confirmButtonText, cancelButtonText?) {
    if (arguments.length === 4) {
        return Swal.fire(
            sweetAlertOneButtons(title, text, type, confirmButtonText)
        );
    } else if (arguments.length === 5) {
        return Swal.fire(
            sweetAlertTwoButtons(title, text, type, confirmButtonText, cancelButtonText)
        );
    }
}


export function sweetAlertWithTwoCheckboxes(
  title,
  text,
  type,
  confirmButtonText,
  cancelButtonText?
) {
  const swalFormat: any = {
    title,
    html: `
      <p>${text}</p>
      <div style="text-align:left; margin-top:24px;">
        <label>
          <input type="checkbox" class="mr-1" id="isUpdateSameDayLegs">
         Apply changes to same day other legs.
        </label>
        <br>
        <label style="margin-top:8px; display:block;">
          <input type="checkbox" class="mr-1" id="isUpdateFutureLegs">
            Apply changes to all future trips of this member.
        </label>
      </div>
    `,
    icon: type,
    showCancelButton: !!cancelButtonText,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor: cancelButtonText ? "#d33" : "#5163B7",
    cancelButtonColor: "#5163B7",

    preConfirm: () => {
      const isUpdateSameDayLegs = (document.getElementById("isUpdateSameDayLegs") as HTMLInputElement).checked;
      const isUpdateFutureLegs = (document.getElementById("isUpdateFutureLegs") as HTMLInputElement).checked;

      return { isUpdateSameDayLegs, isUpdateFutureLegs };
    }
  };

  return Swal.fire(swalFormat);
}

export function sweetAlertWithHtml(title, text, type, confirmButtonText, html) {
    const swalFormat: any = {
        title,
        text,
        html,
        icon: type === 'alert' ? 'warning' : type,
        confirmButtonColor: type === 'warning' || type === 'error' || type === 'alert' ? '#d33' : '#5163B7',
        confirmButtonText
    };
    return Swal.fire(swalFormat);
}

export function sweetAlertWithInput(
  title: string,
  text: string,
  inputPlaceholder: string = 'Enter reason...',
  confirmButtonText: string = 'Submit',
  cancelButtonText: string = 'Cancel',
  isRequired: boolean = true
) {
  return Swal.fire({
    title,
    text,
    input: 'textarea',
    inputPlaceholder,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#5163B7',
    inputValidator: (value) => {
      if (isRequired && (!value || !value.trim())) {
        return 'Please enter a reason!';
      }
    }
  });
}


